export default __webpack_public_path__ + "static/media/small.bd49a2be.jpg";